import { Controller } from "@hotwired/stimulus";

// 指標切替コントローラー
// 指標プルダウン変更時にTurbo Frameのsrcを切り替えてリクエストする
export class MetricSwitcherController extends Controller {
  static targets = ["metricSelect", "yearSelect"];
  static values = { frameId: String };

  switchMetric(event) {
    const basePath = event.target.value;
    // 年セレクタの値を取得（複数yearSelectがある場合、最初の値を使用）
    const yearSelect = this.yearSelectTargets[0];
    const year = yearSelect ? yearSelect.value : "";
    const url = year ? `${basePath}?year=${year}` : basePath;

    const frame = document.getElementById(this.frameIdValue);
    if (frame) {
      frame.src = url;
    }
  }
}
